import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/BoundingBox.es.js";
const n = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...e, weights: a }));
n.displayName = "BoundingBoxIcon";
const c = n;
export {
  c as BoundingBox,
  n as BoundingBoxIcon
};
